import React from "react";
import {Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import {formatDate, money} from "../format.js";
import {PnlTooltip} from "./PnlTooltip.jsx";

export function PnlBars({dailyPnl, animate = true}) {
    return (
        <div className="chart-frame">
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={dailyPnl} margin={{top: 8, right: 12, left: 8, bottom: 0}}>
                    <CartesianGrid strokeDasharray="2 4" stroke="#1e293b"/>
                    <XAxis dataKey="date" tickFormatter={(value) => formatDate(String(value))} minTickGap={24}/>
                    <YAxis tickFormatter={(value) => money(Number(value))}/>
                    <Tooltip content={<PnlTooltip/>}/>
                    <Bar
                        dataKey="pnl" name="Daily PnL" radius={4}
                        isAnimationActive={animate}
                    >
                        {dailyPnl.map((entry) => <Cell key={entry.date} fill={entry.pnl >= 0 ? "#10b981" : "#f43f5e"}/>)}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}
